module.exports = __webpack_public_path__ + "static/media/connect-bubble.33325df2.svg";